var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobboardtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85192 6.9108L9.61171 8.23064L7.85192 6.9108ZM7.85192 6.9108V4.21197C7.85192 3.88514 7.58762 3.62085 7.2608 3.62085C6.93397 3.62085 6.66968 3.88514 6.66968 4.21197V7.20639C6.66968 7.39238 6.75705 7.56802 6.90622 7.67936C6.90625 7.67938 6.90628 7.6794 6.90631 7.67943L8.90239 9.1765C9.00868 9.25622 9.13303 9.29472 9.25656 9.29472C9.43621 9.29472 9.61392 9.2139 9.73004 9.05766C9.92626 8.79677 9.87288 8.42627 9.61176 8.23068L7.85192 6.9108Z",
    fill: "#6D7D8B",
    stroke: "#6D7D8B",
    strokeWidth: 0.184085
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26328 0.632567C3.65958 0.632567 0.72827 3.56388 0.72827 7.16758C0.72827 10.7713 3.65958 13.7026 7.26328 13.7026C10.867 13.7026 13.7983 10.7713 13.7983 7.16758C13.7983 3.56388 10.867 0.632567 7.26328 0.632567ZM7.26328 12.5204C4.31222 12.5204 1.91049 10.1186 1.91049 7.16758C1.91049 4.21652 4.31222 1.81478 7.26328 1.81478C10.2148 1.81478 12.6161 4.21651 12.6161 7.16758C12.6161 10.1186 10.2143 12.5204 7.26328 12.5204Z",
    fill: "#6D7D8B",
    stroke: "#6D7D8B",
    strokeWidth: 0.184085
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobboardtime);
export default __webpack_public_path__ + "static/media/jobboardtime.f2010f5e.svg";
export { ForwardRef as ReactComponent };